
export class EnumModel {
  public id: any;
  public name = '';

  static GetByIdOrFirst( array: EnumModel[], id: any): EnumModel {
    if (id) {
      for (const elem of array) {
        if (elem.id === id.toString()) {
          return elem;
        }
      }
    }
    return array[0];
  }
  constructor(id?: any, name?: string) {
    this.id = id;
    this.name = name;
  }

}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/objects/EnumModel.ts